var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styles from './Checkbox.module.css';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Checkbox(_a) {
    var label = _a.label, checked = _a.checked, setChecked = _a.setChecked, style = _a.style, disabled = _a.disabled, square = _a.square;
    return (React.createElement("div", { style: __assign(__assign({}, style), { marginBottom: '10px' }) },
        React.createElement("label", { style: { color: disabled ? '#b4b4b4' : '' }, className: styles.container },
            React.createElement("input", { type: 'checkbox', checked: checked, onChange: function (event) { return setChecked(event.target.checked); }, disabled: disabled }),
            React.createElement("span", { className: square ? styles.checkmarkSquare : styles.checkmark, style: {
                    backgroundColor: disabled && !checked ? '#F0F1F5' : '',
                    opacity: disabled && checked ? 0.5 : ''
                } }),
            label)));
}
